<div class="tabs">
    <div class="tab" *ngFor='let t of windows' (click)='maximize($event, t)'>{{ t.title }}</div>
</div>
<div class="info-line">
    <div class="info" *ngIf="network">
        {{ network }}
    </div>
    <div class="info" *ngIf="walletVersion">
        {{ walletVersion }}
    </div>
</div>
